<template>
    <div class="property-details-contact-real-estate-agent">
        <h1 class="property-details-contact-real-estate-agent-title text-center">
            Interested?
        </h1>
        <p class="property-details-contact-real-estate-agent-description">
            {{ message }}
        </p>
        <b-btn
                v-if="!isRealEstateTypeExcludedInOrganization || undefined !== realEstateAgent"
                block
                class="property-details-contact-real-estate-agent-btn mb-0 py-2 mt-1"
                variant="primary"
                @click="handleContactRealEstateAgent"
        >
            <span v-if="realEstateAgent">
                Contact {{ realEstateAgentFirstName }}
            </span>
            <span v-else>
                Find a Real Estate Agent
            </span>
        </b-btn>
    </div>
</template>

<script>
    import './PropertyDetailsContactRealEstateAgent.scss';
    import get from 'lodash/get';
    import {mapGetters, mapMutations} from 'vuex';
    import {ApiFilter, AppResourceSearch, AppResource} from '@milestoneslabs/milestones-js-engine';
    import {
        REAL_ESTATE_AGENT
    } from "@milestoneslabs/milestones-core-js/src/AppResources/LuWorkspaceMembershipTypeAppResource";

    export default {
        name: 'PropertyDetailsContactRealEstateAgent',

        props: {
            realEstateAgent: {
                type: Object,
                required: false,
            },
            workspaceUuid: {
                type: String,
                required: true,
            },
            isRealEstateTypeExcludedInOrganization: {
                type: Boolean,
                required: true,
            },
            homeOwnershipBuyHomeModal: {
                type: String,
                required: false,
            },
            propertyAppResource: {
                type: AppResource,
                required: true,
            },
        },
        data() {
            return {
                serviceProviderTypeAppResourceSearch: new AppResourceSearch('service-provider-type'),
            };
        },
        computed: {
            ...mapGetters({
                hub: 'getCurrentWorkspace',
            }),
            realEstateAgentFirstName() {
                return get(this.realEstateAgent, 'user.firstName');
            },
            message() {
                return this.isRealEstateTypeExcludedInOrganization && undefined === this.realEstateAgent
                    ? 'If you\'re in purchasing this home, you should talk to a real estate agent.'
                    : 'Find your next home by setting up a private collaboration hub to manage your home purchase.';
            },
        },

        methods: {
            ...mapMutations('marketplace', {
                setFilterType: 'SET_FILTER_TYPE',
            }),

            async handleContactRealEstateAgent() {
                if (undefined === this.realEstateAgent) {
                    await this.fetchAndSetCategoryFilter();
                    this.$router.push({
                        name: 'marketplace.directory',
                        query: {
                            projectUuid: this.workspaceUuid,
                        }
                    });

                    return;
                }

                const propertyAddress = this.propertyAppResource.addresses.getFirst();
                const address = `${propertyAddress.street} ${propertyAddress.city}, ${propertyAddress.state}`;

                this.$bus.$emit(
                    this.homeOwnershipBuyHomeModal,
                    REAL_ESTATE_AGENT,
                    this.realEstateAgent.user,
                    true,
                    address
                );
            },

            async fetchAndSetCategoryFilter() {
                await this.serviceProviderTypeAppResourceSearch.setSearchData({
                    pagination: 'disabled',
                    limit: 1,
                    filter: new ApiFilter({
                        params: {
                            title: 'Real Estate Agents',
                        },
                    }),
                }, false);

                try {
                    await this.serviceProviderTypeAppResourceSearch.search();
                    const realEstateAgentsType = this.serviceProviderTypeAppResourceSearch.appResourceCollection.getFirst();
                    await this.setFilterType({
                        uuid: realEstateAgentsType.uuid,
                        title: realEstateAgentsType.title
                    });
                } catch (e) {
                    console.error(e);
                }
            }
        },
    };
</script>
